export default __webpack_public_path__ + "static/media/sidebar_places_blue.b851b4db.svg";